const initialState = {
  cartsAbandoned: [],
  userWithQuotation: { rows: [] },
  userWithoutPurchase: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ABANDONED_ITEMS':
      return {
        ...state,
        cartsAbandoned: action.cartsAbandoned,
        userWithQuotation: action.userWithQuotation,
        userWithoutPurchase: action.userWithoutPurchase,
      };
    default:
      return state;
  }
};
